'use client';

import React, { useEffect, useState } from 'react';

function CookieManager() {
  const [oneTrustAvailable, setOneTrustAvailable] = useState(false);

  useEffect(() => {
    const checkOneTrust = setInterval(() => {
      if (
        typeof window.OneTrust !== 'undefined' &&
        typeof window.OneTrust.ToggleInfoDisplay === 'function'
      ) {
        setOneTrustAvailable(true);
        clearInterval(checkOneTrust);
      }
    }, 500);
    return () => clearInterval(checkOneTrust);
  }, []);

  const openConsentModal = () => {
    if (oneTrustAvailable) {
      window.OneTrust.ToggleInfoDisplay();
    } else {
      console.error('OneTrust not available!');
    }
  };

  return (
    <button
      type="button"
      onClick={openConsentModal}
      className="block whitespace-nowrap text-sm text-neutral-40 underline duration-200 ease-in hover:text-white"
    >
      Cookies
    </button>
  );
}

export default CookieManager;
